import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petition/comments/pageContext';

export function PetitionCommentsErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for PetitionComments page (error: ${error})`);
}
